import { useMemo } from "react";
import useGroups from "../../../../../../../../../api/useGroups";

export const useAnalysisLastCycle = (projectId: string) => {
  const cycle = useGroups(projectId).at(-1);
  return useMemo(() => (cycle ? { from: cycle.startDate, to: cycle.endDate } : undefined), [cycle]);
};
